import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { formatDateTime } from "../../helpers/helpers";
import ActionTable from "../../components/table/ActionTable";
import promocaoCondicao from "../../enums/promocaoCondicao";
import { CircularProgress } from "@mui/material";

export default function Promocao(props) {
  const [promocaoId] = useState(Number(props.match.params.id));
  const [comboProdutos, setComboProdutos] = useState([]);
  const [comboCategorias, setComboCategorias] = useState([]);
  const [promocao, setPromocao] = useState({});
  const [novaCondicao, setNovaCondicao] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [condicaoEditar, setCondicaoEditar] = useState({});
  const [exibindoForm, setExibindoForm] = useState(false);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(0);
  const { notification } = useContext(AppContext);
  const history = props.history;

  useEffect(() => {
    if (promocaoId > 0) {
      carregar();
    }
    carregarComboProdutos();
    carregarComboCategorias();
  }, []);

  const carregar = () => {
    // this.setState({ carregando: true });
    setCarregando(true);

    api
      .get("promocoes/carregar", { id: promocaoId })
      .then((promocao) => {
        setPromocao(promocao);
        setCarregando(false);
      })
      .catch((e) =>
        notification("error", "Não foi possível carregar a promoção")
      );
  };

  const carregarComboProdutos = () => {
    api
      .get("produtos/listar")
      .then((comboProdutos) => {
        setComboProdutos(comboProdutos);
      })
      .catch((e) =>
        notification("error", "Não foi possível listar os produtos: " + e)
      );
  };

  const carregarComboCategorias = () => {
    api
      .get("produtos/listarcategorias")
      .then((comboCategorias) => {
        setComboCategorias(comboCategorias);
      })
      .catch((e) =>
        notification("error", "Não foi possível listar as categorias: " + e)
      );
  };

  const salvar = (formulario) => {
    const promocaoSalvar = formulario;

    promocaoSalvar.id = promocao.id;

    if (promocaoSalvar.valor) {
      promocaoSalvar.valorCentavos = (promocaoSalvar.valor * 100).toFixed(0);

      promocaoSalvar.pctDesconto = null;
    } else {
      if (
        !promocaoSalvar.pctDesconto ||
        promocaoSalvar.pctDesconto < 1 ||
        promocaoSalvar.pctDesconto > 100
      ) {
        return notification(
          "warning",
          "a % de desconto deve ser um valor entre 1 e 100."
        );
      }

      promocaoSalvar.valorCentavos = null;
    }

    if (promocao.id > 0) {
      api
        .post("promocoes/editar", promocaoSalvar)
        .then((res) => {
          notification("success", "Promoção salva!");
          history.push(`/app/promocao`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Início inválido");
            case 2:
              return notification(
                "error",
                "Valor e porcentagem de descontos não informados (um deve ser informado)"
              );
            case 3:
              return notification("error", "Produto inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("promocoes/inserir", promocaoSalvar)
        .then((res) => {
          notification("success", "Promoção salva!");
          history.push(`/app/promocao`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Início inválido");
            case 2:
              return notification(
                "error",
                "Valor e porcentagem de descontos não informados (um deve ser informado)"
              );
            case 3:
              return notification("error", "Produto inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fDados = {
    form: {
      produtoId: {
        label: "Produto",
        type: "select",
        emptyItem: true,
        array: {
          data: comboProdutos,
          value: "id",
          desc: "nome",
        },
        value: promocao.produtoId,
        space: 6,
      },
      inicio: {
        label: "Início",
        type: "date",
        value: promocao.inicio
          ? formatDateTime(promocao.inicio, "Y-M-D")
          : null,
        required: true,
        space: 3,
      },
      fim: {
        label: "Fim",
        type: "date",
        value: promocao.fim ? formatDateTime(promocao.fim, "Y-M-D") : null,
        space: 3,
      },
      descricao: {
        label: "Descrição",
        type: "textarea",
        value: promocao.descricao,
      },
      valor: {
        label: "Valor R$ (0 ou nulo para usar porcentagem)",
        type: "number",
        value: promocao.valorCentavos
          ? (promocao.valorCentavos / 100).toFixed(2)
          : null,
        space: 6,
      },
      pctDesconto: {
        label: "% de desconto",
        type: "number",
        value: promocao.pctDesconto,
        space: 6,
      },
    },

    submit: {
      label: "salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  const editar = (cond) => {
    setCondicaoEditar(cond);
    setCondicaoSelecionada(cond.condicao);
    setExibindoForm(true);
  };

  const tCondicoes = {
    title: "Condições",
    array: promocao.condicoes,
    columns: [
      {
        name: "condicao",
        label: "Condição",
        domain: promocaoCondicao,
      },
      {
        name: "valor",
        label: "Valor de referência",
      },
    ],
    onLineClick: editar,
    newItemAction: () => {
      setNovaCondicao(true);
      setExibindoForm(true);
    },
  };

  const selecionarCondicao = (tipo) => {
    setCondicaoSelecionada(tipo.condicao);
  };

  const fCondicaoSelecao = {
    title: "Selecione a condição",
    form: {
      condicao: {
        label: "Condição",
        type: "select",
        emptyItem: true,
        // space: 3,
        array: {
          data: [
            { id: 1, nome: "Na compra de [Nº] produtos" },
            { id: 2, nome: "Na compra de [Nº] produtos da categoria" },
          ],
          value: "id",
          desc: "nome",
        },
        value: condicaoEditar.condicao
          ? condicaoEditar.condicao
          : condicaoSelecionada,
      },
    },

    submit: {
      auto: true,
      action: selecionarCondicao,
    },
  };

  const camposCondicao = () => {
    const form = {
      valor: {
        label: "Valor de referência",
        type: "number",
        value: condicaoEditar.valor,
        space: 4,
      },
    };

    switch (condicaoSelecionada) {
      case 1:
        form.IDReferencia = {
          label: "Produto de referência",
          type: "select",
          emptyItem: true,
          array: {
            data: comboProdutos,
            value: "id",
            desc: "nome",
          },
          value: condicaoEditar.IDReferencia,
          space: 4,
        };
        break;

      case 2:
        form.IDReferencia = {
          label: "Categoria de referência",
          type: "select",
          emptyItem: true,
          emptyItemText: "(Nenhum)",
          array: {
            data: comboCategorias,
            value: "id",
            desc: "nome",
          },
          value: condicaoEditar.IDReferencia,
          space: 4,
        };
        break;

      default:
        break;
    }

    form.historicoAPartirDe = {
      label: "Histórico até",
      type: "date",
      value: condicaoEditar.historicoAPartirDe,
      space: 4,
    };

    return form;
  };

  const salvarCondicao = (form) => {
    const dadosEnviar = form;
    dadosEnviar.promocaoId = promocaoId;
    dadosEnviar.condicao = condicaoSelecionada;
    if (condicaoEditar.id > 0) {
      dadosEnviar.id = condicaoEditar.id;
      api
        .post("promocoes/editarCondicao", dadosEnviar)
        .then((res) => {
          notification("success", "Condição salva!");
          setCondicaoEditar({});
          setNovaCondicao(false);
          setExibindoForm(false);
          carregar();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Condição inválida");
            case 2:
              return notification("error", "Valor de referência inválido");

            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("promocoes/inserirCondicao", dadosEnviar)
        .then((res) => {
          notification("success", "Condição salva!");
          setCondicaoEditar({});
          setNovaCondicao(false);
          setExibindoForm(false);
          carregar();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Condição inválida");
            case 2:
              return notification("error", "Valor de referência inválido");

            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const excluirCondicao = () => {
    api
      .delete("promocoes/removerCondicao", { id: condicaoEditar.id })
      .then((res) => {
        notification("warning", "Condição removida!");
        setCondicaoEditar({});
        setExibindoForm(false);
        carregar();
      })
      .catch((err) => {
        return notification("error", "Dados inválidos");
      });
  };

  const fCondicao = {
    title: novaCondicao ? "Nova condição" : "Alterar condição",
    form: camposCondicao(),
    submit: {
      label: "Salvar condição",
      action: salvarCondicao,
    },
    close: {
      label: "Fechar",
      action: () => {
        setCondicaoEditar({});
        setNovaCondicao(false);
        setExibindoForm(false);
      },
    },

    customActions: novaCondicao
      ? undefined
      : [
          {
            label: "Excluir",
            action: excluirCondicao,
          },
        ],
  };

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fDados} />
          {promocaoId > 0 && (
            <>
              {exibindoForm ? (
                <>
                  <Form formData={fCondicaoSelecao} />
                  <Form formData={fCondicao} />
                </>
              ) : (
                <ActionTable structure={tCondicoes} />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
